import Banner1 from './Variants/Banner1'
import Banner2 from './Variants/Banner2'
import Banner3 from './Variants/Banner3'
import Banner4 from './Variants/Banner4'
import Banner5 from './Variants/Banner5'
import Banner6 from './Variants/Banner6'
import Banner7 from './Variants/Banner7'
import Banner8 from './Variants/Banner8'
// eslint-disable-next-line camelcase
import Banner9_10 from './Variants/Banner9_10'
import Banner11 from './Variants/Banner11'
import Banner12 from './Variants/Banner12'
import Banner13 from './Variants/Banner13'
import Banner14 from './Variants/Banner14'
import Banner15 from './Variants/Banner15'
import Banner16 from './Variants/Banner16'
import Banner17 from './Variants/Banner17'
import Banner23 from './Variants/Banner23'

export const BANNER_VARIANTS = Object.freeze({
	VARIANT_1: 'banner-1',
	VARIANT_2: 'banner-2',
	VARIANT_3: 'banner-3',
	VARIANT_4: 'banner-4',
	VARIANT_5: 'banner-5',
	VARIANT_6: 'banner-6',
	VARIANT_7: 'banner-7',
	VARIANT_8: 'banner-8',
	VARIANT_9_10: 'banner-9_10',
	VARIANT_11: 'banner-11',
	VARIANT_12: 'banner-12',
	VARIANT_13: 'banner-13',
	VARIANT_15: 'banner-15',
	VARIANT_14: 'banner-14',
	VARIANT_16: 'banner-16',
	VARIANT_17: 'banner-17',
	VARIANT_23: 'banner-23',
})

export const VARIANTS = Object.freeze({
	[BANNER_VARIANTS.VARIANT_1]: Banner1,
	[BANNER_VARIANTS.VARIANT_2]: Banner2,
	[BANNER_VARIANTS.VARIANT_3]: Banner3,
	[BANNER_VARIANTS.VARIANT_4]: Banner4,
	[BANNER_VARIANTS.VARIANT_5]: Banner5,
	[BANNER_VARIANTS.VARIANT_6]: Banner6,
	[BANNER_VARIANTS.VARIANT_7]: Banner7,
	[BANNER_VARIANTS.VARIANT_8]: Banner8,
	[BANNER_VARIANTS.VARIANT_9_10]: Banner9_10,
	[BANNER_VARIANTS.VARIANT_11]: Banner11,
	[BANNER_VARIANTS.VARIANT_12]: Banner12,
	[BANNER_VARIANTS.VARIANT_13]: Banner13,
	[BANNER_VARIANTS.VARIANT_14]: Banner14,
	[BANNER_VARIANTS.VARIANT_15]: Banner15,
	[BANNER_VARIANTS.VARIANT_16]: Banner16,
	[BANNER_VARIANTS.VARIANT_17]: Banner17,
	[BANNER_VARIANTS.VARIANT_23]: Banner23,
})
